import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../../store/JSTool';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../../store/SettingSlice';


export default function MobileMenu(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    function itemTap(i) {
        JSTool.hideMenu();
        if (i == 0) {
            navigate('/newsList');

        } else if (i == 1) {
            navigate('/about');

        } else if (i == 2) {
            navigate('/recruit');

        } else if (i == 3) {
            navigate('/contact');
        }
    }

    return (
        <Stack
            id='_menu_view'
            sx={{
                width: 1,
                bgcolor: 'black',
                position: 'absolute',
                zIndex: 999,
                top: '50px',
                display: 'none',
            }}>
            <Item title={settingData.langDic['lang2']} index={0} itemTap={itemTap} />
            <Item title={settingData.langDic['lang3']} index={1} itemTap={itemTap} />
            <Item title={settingData.langDic['lang4']} index={2} itemTap={itemTap} />
            <Item title={settingData.langDic['lang5']} index={3} itemTap={itemTap} />
        </Stack>
    );
}

function Item(props) {
    return (
        <Stack onClick={() => props.itemTap(props.index)}>
            <Typography sx={{
                color: 'white',
                fontSize: 16,
                height: '60px',
                lineHeight: '60px',
                fontWeight: 'bold',
                pr: 3,
                pl: 3,
                textAlign: 'center',
            }}>
                {props.title}
            </Typography>
            <Box sx={{
                width: 1,
                height: '1px',
                bgcolor: '#C9CDD140',
            }} />
        </Stack>
    );
}